import script from "./BurgerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BurgerButton.vue?vue&type=script&setup=true&lang=js"

import "./BurgerButton.vue?vue&type=style&index=0&id=bc7dfa3e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc7dfa3e"]])

export default __exports__